document.addEventListener('DOMContentLoaded', () => {
  const progressPath = document.querySelector('.button__back-to-top .progress-circle path');
  if (!progressPath) return;

  const pathLength = progressPath.getTotalLength();

  // Initial setup of the progress path
  progressPath.style.transition = progressPath.style.WebkitTransition = 'none';
  progressPath.style.strokeDasharray = `${pathLength} ${pathLength}`;
  progressPath.style.strokeDashoffset = pathLength;
  progressPath.getBoundingClientRect(); // force layout
  progressPath.style.transition = progressPath.style.WebkitTransition = 'none';

  let lastProgress = null;
  let lastScroll;

  function getScrollY() {
    return window.scrollY || window.pageYOffset;
  }

  function updateProgress() {
    const scroll = getScrollY();
    let height = document.documentElement.scrollHeight - window.innerHeight;
    if (height <= 0) height = 1;

    // ✅ Optimization: only update if scroll moved by >5px
    if (typeof lastScroll !== 'undefined' && Math.abs(scroll - lastScroll) < 5) return;
    lastScroll = scroll;

    const progress = pathLength - (scroll * pathLength) / height;
    if (lastProgress !== progress) {
      progressPath.style.strokeDashoffset = progress;
      lastProgress = progress;
    }
  }

  // ✅ Optimized RAF loop to prevent multiple calls per frame
  let isRafRunning = false;
  function rafLoop() {
    if (!isRafRunning) {
      isRafRunning = true;
      window.requestAnimationFrame(() => {
        updateProgress(); // keeps original logic
        isRafRunning = false;
      });
    }
  }

  // Initial render
  updateProgress();
  rafLoop();

  // Event listeners
  window.addEventListener('resize', theme.utils.rafThrottle(updateProgress));
  window.addEventListener('scroll', rafLoop, { passive: true }); // ✅ Optimized scroll handling
});